import { render, staticRenderFns } from "./phoenix.vue?vue&type=template&id=8a279b9a&scoped=true&"
import script from "./phoenix.vue?vue&type=script&lang=js&"
export * from "./phoenix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a279b9a",
  null
  
)

export default component.exports